import { render, staticRenderFns } from "./ModalReclamarGarantia.vue?vue&type=template&id=6f97ce5c&"
import script from "./ModalReclamarGarantia.vue?vue&type=script&lang=js&"
export * from "./ModalReclamarGarantia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports